import Swiper, { Navigation, EffectFade, Lazy, Autoplay } from 'swiper';

Swiper.use([Navigation, EffectFade, Lazy, Autoplay]);

const sliderEl = document.querySelector('[data-js=casecardsingle-carousel]');
const timeOut = sliderEl
	.querySelector('[data-timeout-js]')
	.getAttribute('data-timeout-js');
const nextEl = document.querySelector('[data-js=casecardsingle-next]');
const prevEl = document.querySelector('[data-js=casecardsingle-prev]');
const progressBarActive = document.querySelector(
	'[data-js=casecardsingle-progress-bar]'
);

// eslint-disable-next-line no-new
new Swiper(sliderEl, {
	slidesPerView: 1,
	loop: true,
	navigation: { nextEl, prevEl },
	autoplay: {
		delay: timeOut,
		disableOnInteraction: false,
	},
	on: {
		init: () => {
			progressBarActive.classList.add('init');
		},
		realIndexChange: () => {
			progressBarActive.classList.remove('init');
			progressBarActive.classList.add('rollback');
		},
		slideChangeTransitionEnd: () => {
			progressBarActive.classList.add('init');
			progressBarActive.classList.remove('rollback');
		},
	},
});
